"use client";

import React, { useEffect, useState } from "react";
import axios from 'axios';

import Chatbot from "../components/Chatbot";
import Footer from "../components/common/Footer"

function Contact() {

  useEffect(() => {
    // Mobile menu toggle
    const menuBtn = document.getElementById("menu-btn");
    const mobileMenu = document.getElementById("mobile-menu");

    const handleMenuToggle = () => {
      if (mobileMenu) {
        mobileMenu.classList.toggle("hidden");
      }
    };

    if (menuBtn) {
      menuBtn.addEventListener("click", handleMenuToggle);
    }

    // FAQ toggle function
    window.toggleFAQ = (element) => {
      const faqItem = element;
      const faqAnswer = faqItem.querySelector(".faq-answer");
      const plusIcon = faqItem.querySelector(".plus-icon");
      const minusIcon = faqItem.querySelector(".minus-icon");

      faqAnswer.classList.toggle("hidden");
      plusIcon.classList.toggle("hidden");
      minusIcon.classList.toggle("hidden");
    };

    return () => {
      if (menuBtn) {
        menuBtn.removeEventListener("click", handleMenuToggle);
      }
      window.toggleFAQ = null;
    };
  }, []);

  return (
    <div>
      <Chatbot />

      <main className="flex overflow-hidden flex-col pb-11 bg-white">
        {/* Hero Section */}
        <header className="bg-indigo-950 flex relative flex-col items-center self-stretch px-20 w-full text-white max-md:px-5 max-md:pb-24 max-md:max-w-full">
          <nav className="flex items-center justify-between w-full max-w-[1248px] px-5 py-3 relative mx-auto">
            {/* Logo */}
            <img
              src="https://cdn.builder.io/api/v1/image/assets/TEMP/6f92263fde794fd91fb10442848bed84da061cb6?placeholderIfAbsent=true&apiKey=a6aeafbfb8ee495fa82398b0de2ab431"
              alt="Company logo"
              className="w-[101px] object-contain"
            />

            {/* Mobile Menu Button */}
            <button id="menu-btn" className="block md:hidden text-white focus:outline-none">
              <svg
                className="w-8 h-8"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M4 6h16M4 12h16m-7 6h7"
                ></path>
              </svg>
            </button>

            {/* Navigation Wrapper */}
            <div id="menu" className="hidden md:flex relative items-center">
              {/* Background behind menu */}
              <div className="absolute inset-0 w-full h-full bg-white rounded-full"></div>

              {/* Menu Items */}
              <ul className="flex gap-10 px-8 py-3 text-indigo-950 text-base font-medium relative z-10">
                <li className="cursor-pointer">
                  <a href="/">Home</a>
                </li>
                <li className="cursor-pointer">
                  <a href="/services">Services</a>
                </li>
                <li className=" cursor-pointer">
                  <a href="/projects">Projects</a>
                </li>
                <li className="cursor-pointer">
                  <a href="/about">About</a>
                </li>
              </ul>
            </div>

            {/* Contact Button */}
            <button className="px-5 py-2 bg-white text-indigo-950 font-bold rounded-full hidden md:block">
              <a href="/contact">Contact Us</a>
            </button>

            {/* Mobile Dropdown */}
            <div id="mobile-menu" className="absolute top-full left-0 w-full bg-white shadow-md hidden md:hidden">
              <ul className="flex flex-col items-center gap-4 py-4 text-indigo-950 font-medium">
                <li className="cursor-pointer">
                  <a href="/">Home</a>
                </li>
                <li className="cursor-pointer">
                  <a href="/services">Services</a>
                </li>
                <li className="cursor-pointer">
                  <a href="/projects">Projects</a>
                </li>
                <li className="cursor-pointer">
                  <a href="/about">About</a>
                </li>
                <li>
                  <a href="/contact">
                    <button className="px-5 py-2 bg-white text-indigo-950 font-bold rounded-full">
                      Contact Us
                    </button>
                  </a>
                </li>
              </ul>
            </div>
          </nav>
        </header>

        <header className="flex flex-col items-center px-0 pb-0 bg-indigo-950">
          <h1 className="text-6xl font-bold tracking-tighter text-center text-white max-w-[717px] max-sm:px-5 max-sm:py-0 max-sm:mb-36 max-sm:text-4xl">
            Get in Touch – We're Here to Help!
          </h1>
          <img src="assets/img/man.png" alt="Man with headphones" />
          <div className="flex gap-4 items-center max-sm:flex-col max-sm:mb-20 sdsd">
            <div className="flex items-center">
              <div className="flex justify-center items-center p-0.5 -mr-5 w-12 h-12 bg-white rounded-3xl z-[3]">
                <img
                  src="https://cdn.builder.io/api/v1/image/assets/TEMP/9b421553e6860f8ebbd7fb0caf4cdf29bcb03a2a?placeholderIfAbsent=true&apiKey=a6aeafbfb8ee495fa82398b0de2ab431"
                  alt=""
                  className="w-11 h-11 rounded-3xl"
                />
              </div>
              <div className="flex justify-center items-center p-0.5 -mr-5 w-12 h-12 bg-white rounded-3xl z-[3]">
                <img
                  src="https://cdn.builder.io/api/v1/image/assets/TEMP/fad6d616fa8eba92fb0898693d31da08c9254e7f?placeholderIfAbsent=true&apiKey=a6aeafbfb8ee495fa82398b0de2ab431"
                  alt=""
                  className="w-11 h-11 rounded-3xl"
                />
              </div>
              <div className="flex justify-center items-center p-0.5 -mr-5 w-12 h-12 bg-white rounded-3xl z-[3]">
                <img
                  src="https://cdn.builder.io/api/v1/image/assets/TEMP/d5f1e449a21c3a3575b28859dd35bce0e291af31?placeholderIfAbsent=true&apiKey=a6aeafbfb8ee495fa82398b0de2ab431"
                  alt=""
                  className="w-11 h-11 rounded-3xl"
                />
              </div>
              <div className="flex gap-1 ml-9">
                <div>
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="star-icon"
                    style={{ width: "24px", height: "24px" }}
                  >
                    <path
                      d="M12 17.77L18.18 21.5L16.54 14.47L22 9.74L14.81 9.13L12 2.5L9.19 9.13L2 9.74L7.46 14.47L5.82 21.5L12 17.77Z"
                      fill="#FFC500"
                    ></path>
                  </svg>
                </div>
                <div>
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="star-icon"
                    style={{ width: "24px", height: "24px" }}
                  >
                    <path
                      d="M12 17.77L18.18 21.5L16.54 14.47L22 9.74L14.81 9.13L12 2.5L9.19 9.13L2 9.74L7.46 14.47L5.82 21.5L12 17.77Z"
                      fill="#FFC500"
                    ></path>
                  </svg>
                </div>
                <div>
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="star-icon"
                    style={{ width: "24px", height: "24px" }}
                  >
                    <path
                      d="M12 17.77L18.18 21.5L16.54 14.47L22 9.74L14.81 9.13L12 2.5L9.19 9.13L2 9.74L7.46 14.47L5.82 21.5L12 17.77Z"
                      fill="#FFC500"
                    ></path>
                  </svg>
                </div>
                <div>
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="star-icon"
                    style={{ width: "24px", height: "24px" }}
                  >
                    <path
                      d="M12 17.77L18.18 21.5L16.54 14.47L22 9.74L14.81 9.13L12 2.5L9.19 9.13L2 9.74L7.46 14.47L5.82 21.5L12 17.77Z"
                      fill="#FFC500"
                    ></path>
                  </svg>
                </div>
                <div>
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="star-icon"
                    style={{ width: "24px", height: "24px" }}
                  >
                    <path
                      d="M12 17.77L18.18 21.5L16.54 14.47L22 9.74L14.81 9.13L12 2.5L9.19 9.13L2 9.74L7.46 14.47L5.82 21.5L12 17.77Z"
                      fill="#FFC500"
                    ></path>
                  </svg>
                </div>
              </div>
              {/* <p className="ml-4 text-base text-white">From 50+ reviews</p> */}
            </div>
          </div>
        </header>

        <section className="flex flex-col items-center px-96 py-20 max-md:px-10 max-md:py-20 max-sm:px-5 max-sm:py-10">
          <h2 className="mb-5 text-4xl font-bold text-center text-black text-opacity-80">Send Us a Message</h2>
          <p className="mb-16 text-base text-center text-black text-opacity-60">
            For inquiries, consultations, or service requests, contact us today!
          </p>
          <form className="flex flex-col gap-8 w-[672px] max-md:w-full">
            <div className="flex gap-8 max-sm:flex-col">
              <div className="flex flex-col flex-1 gap-2">
                <label htmlFor="name" className="text-base text-black text-opacity-80">
                  Name
                </label>
                <div className="flex gap-2.5 items-center px-3.5 py-2.5 bg-white border border-black border-opacity-30 rounded-full">
                  <input
                    type="text"
                    name="name"
                    id="name"
                    placeholder="Enter Your Name"
                    className="w-full text-xs text-black text-opacity-60 outline-none focus:ring-0 focus:outline-none bg-transparent"
                  />
                </div>
              </div>
              <div className="flex flex-col flex-1 gap-2">
                <label htmlFor="email" className="text-base text-black text-opacity-80">
                  Email
                </label>
                <div className="flex gap-2.5 items-center px-3.5 py-2.5 bg-white border border-black border-opacity-30 rounded-full">
                  <input
                    name="email"
                    type="email"
                    id="email"
                    placeholder="Enter Your Email"
                    className="w-full text-xs text-black text-opacity-60 outline-none focus:ring-0 focus:outline-none bg-transparent"
                  />
                </div>
              </div>
            </div>
            <div className="flex gap-8 max-sm:flex-col">
              <div className="flex flex-col flex-1 gap-2">
                <label htmlFor="phone" className="text-base text-black text-opacity-80">
                  Phone
                </label>
                <div className="flex gap-2.5 items-center px-3.5 py-2.5 bg-white border border-black border-opacity-30 rounded-full">
                  <input
                    name="phone"
                    type="tel"
                    id="phone"
                    placeholder="Enter Your Phone"
                    className="w-full text-xs text-black text-opacity-60 outline-none focus:ring-0 focus:outline-none bg-transparent"
                  />
                </div>
              </div>
              <div className="flex flex-col flex-1 gap-2">
                <label htmlFor="service" className="text-base text-black text-opacity-80">
                  Service
                </label>
                <div className="flex relative gap-2.5 items-center px-3.5 py-2.5 bg-white border border-black border-opacity-30 rounded-full">
                  <select
                    id="service"
                    name="service"
                    className="w-full text-xs text-black text-opacity-60 outline-none focus:ring-0 focus:outline-none bg-transparent appearance-none pr-8"
                  >
                    <option value="solar">Solar Solutions</option>
                    <option value="street">Street Pole</option>
                    <option value="electrical">Electrical Services</option>
                    <option value="others">Others</option>
                  </select>

                  <div className="absolute right-4 top-1/2 transform -translate-y-1/2 pointer-events-none">
                    ▼
                  </div>
                </div>
              </div>
            </div>
            <div className="flex flex-col flex-1 gap-2">
              <label htmlFor="description" className="text-base text-black text-opacity-80">
                Description
              </label>
              <div className="flex gap-2.5 items-center px-3.5 py-2.5 bg-white rounded-xl border border-black border-opacity-30">
                <textarea
                  name="message"
                  id="description"
                  placeholder="Write here..."
                  className="w-full text-xs resize-none h-[184px] text-black text-opacity-60 outline-none focus:ring-0 focus:outline-none bg-transparent"
                />

              </div>
            </div>
            <button
              type="submit"
              className="flex gap-2.5 justify-center items-center px-3.5 py-2.5 text-base text-white cursor-pointer bg-indigo-950 border-none rounded-full"
            >
              <span>Send Message</span>
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clipPath="url(#clip0_1_1683)">
                  <path
                    d="M2.91634 2.91667C-0.989302 6.82231 -0.989302 13.1777 2.91634 17.0833C6.82198 20.989 13.1774 20.989 17.083 17.0833C20.9886 13.1777 20.9886 6.82231 17.083 2.91667C13.1774 -0.98897 6.82198 -0.988969 2.91634 2.91667ZM4.00608 4.00641C7.32271 0.68978 12.6766 0.689781 15.9933 4.00641C19.3099 7.32305 19.3099 12.677 15.9933 15.9936C12.6766 19.3102 7.32271 19.3102 4.00608 15.9936C0.689448 12.677 0.689448 7.32305 4.00608 4.00641ZM6.90153 6.11725L6.883 7.66795L11.242 7.66795L5.6407 13.2692L6.73044 14.359L12.3317 8.75769L12.3317 13.1167L13.8824 13.0981L13.8819 6.90132V6.1167H13.0973L6.90044 6.11725L6.90153 6.11725Z"
                    fill="white"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip0_1_1683">
                    <rect width="20" height="20" fill="white"></rect>
                  </clipPath>
                </defs>
              </svg>
            </button>
          </form>
        </section>

        <section className="px-28 py-0 mb-20 max-md:px-10 max-md:py-0 max-sm:px-5 max-sm:py-0">
          <div className="mb-10">
            <h2 className="mb-5 text-4xl font-bold text-black text-opacity-80">
              Frequently Asked Questions
            </h2>
            <p className="text-base text-black text-opacity-60">
              Seamless solar integration for efficient and sustainable industrial power!
            </p>
          </div>

          <div className="flex flex-col gap-6">
            {/* FAQ Item */}
            <div className="ml-auto w-[586px] max-md:w-full">
              <button className="faq-item w-full text-left" onClick={(e) => window.toggleFAQ(e.target.closest('.faq-item'))}>
                <div className="flex justify-between items-center p-5 rounded-[20px] bg-indigo-950">
                  <h3 className="text-xl font-medium tracking-tighter text-white">
                    What Services Does Al-Abbas Electric Provide?
                  </h3>
                  <div className="plus-icon">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M19 13H13V19C13 19.55 12.55 20 12 20C11.45 20 11 19.55 11 19V13H5C4.45 13 4 12.55 4 12C4 11.45 4.45 11 5 11H11V5C11 4.45 11.45 4 12 4C12.55 4 13 4.45 13 5V11H19C19.55 11 20 11.45 20 12C20 12.55 19.55 13 19 13Z"
                        fill="white"
                      />
                    </svg>
                  </div>
                  <div className="minus-icon hidden">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M19 13H5C4.45 13 4 12.55 4 12C4 11.45 4.45 11 5 11H19C19.55 11 20 11.45 20 12C20 12.55 19.55 13 19 13Z" fill="white" />
                    </svg>
                  </div>
                </div>
                <div className="faq-answer hidden p-5 text-base text-white text-opacity-80 bg-indigo-950 rounded-b-[20px]">
                  <p>
                    Al-Abbas Electric provides electrical services including installation, maintenance, and repair
                    for residential, commercial, and industrial clients.
                  </p>
                </div>
              </button>
            </div>

            {/* Repeat for more FAQs */}
            <div className="ml-auto w-[586px] max-md:w-full">
              <button className="faq-item w-full text-left" onClick={(e) => window.toggleFAQ(e.target.closest('.faq-item'))}>
                <div className="flex justify-between items-center p-5 rounded-[20px] bg-indigo-950">
                  <h3 className="text-xl font-medium tracking-tighter text-white">
                    Do You Offer Solar Panel Installation For Homes And Businesses?
                  </h3>
                  <div className="plus-icon">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M19 13H13V19C13 19.55 12.55 20 12 20C11.45 20 11 19.55 11 19V13H5C4.45 13 4 12.55 4 12C4 11.45 4.45 11 5 11H11V5C11 4.45 11.45 4 12 4C12.55 4 13 4.45 13 5V11H19C19.55 11 20 11.45 20 12C20 12.55 19.55 13 19 13Z"
                        fill="white"
                      />
                    </svg>
                  </div>
                  <div className="minus-icon hidden">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M19 13H5C4.45 13 4 12.55 4 12C4 11.45 4.45 11 5 11H19C19.55 11 20 11.45 20 12C20 12.55 19.55 13 19 13Z" fill="white" />
                    </svg>
                  </div>
                </div>
                <div className="faq-answer hidden p-5 text-base text-white text-opacity-80 bg-indigo-950 rounded-b-[20px]">
                  <p>Yes, we offer solar panel installations for both residential and commercial properties.</p>
                </div>
              </button>
            </div>
          </div>
        </section>
      </main>

      <div className="power-up-container">
        <div className="power-up-content">
          <h1 className="font-medium">Let's Power Up Together!</h1>
          <p className="text-[17px] my-5 text-gray-600">
            Have questions or need expert electrical and solar solutions?
            <br />
            Our team is ready to assist you. Get in touch today!
          </p>

          <div className="power-up-form">
            <input type="text" placeholder="Enter Your Name" />
            <input type="text" placeholder="Write Your Phone" />
            <select>
              <option >Select Service</option>
              <option>Solar Solutions</option>
              <option>Street Pole</option>
              <option>Electrical Services</option>
            </select>
            <button>Get Free Quotation</button>
          </div>
        </div>

        <div className="power-up-image">
          <img src="assets/img/man.png" alt="Man with headphones" />
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Contact;